// extracted by mini-css-extract-plugin
export default {"container":"PromoLayout_container__rgjXI"};